import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "payroll-emp201-emp501")!;
const PayrollEmp201Emp501 = () => <ServicePageTemplate data={data} />;
export default PayrollEmp201Emp501;
